var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Loading',{attrs:{"loading":_vm.loading,"solid":""}}),(!_vm.loading)?[(!_vm.isActive)?_c('div',{staticClass:"main col-xl-12"},[_c('NotFound')],1):(!_vm.loading)?_c('div',[_c('AgentRenderer',{attrs:{"publicId":_vm.publicId}})],1):_vm._e()]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }